import { useEffect, useState, useRef } from "react";
import ConfettiExplosion from "react-confetti-explosion";
import { saveWorkout } from "../utils/saveWorkout";
import { toast } from "react-toastify";

export default function CompletePage({ fromLibrary, handleRestart, handleSaveWorkout, user, workout, workoutName }) {
  const [isExploding, setIsExploding] = useState(true);
  const hasProcessedSaveActionRef = useRef(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExploding(false);
    }, 3000); // confetti lasts 3 seconds

    return () => clearTimeout(timer);
  }, []);

  // Handle post-login save workout
  useEffect(() => {
    const handlePostLoginSaveWorkout = async () => {
      if (!user || hasProcessedSaveActionRef.current) return;

      const pendingBookmarkAction = localStorage.getItem("pendingBookmarkAction");
      if (pendingBookmarkAction) {
        const { action } = JSON.parse(pendingBookmarkAction);
        if (action === "saveWorkout") {
          // User came back from login after trying to save workout
          if (workoutName && workout && workout.length > 0) {
            try {
              await saveWorkout({ user, name: workoutName, exercises: workout });
              toast.success("Workout saved to your library!");
              // Navigate to library to show the saved workout
              window.location.href = "/library";
            } catch (err) {
              console.error("Error saving workout after login:", err);
              toast.error("Failed to save workout. Try again.");
            }
          }
          localStorage.removeItem("pendingBookmarkAction");
          hasProcessedSaveActionRef.current = true;
        }
      }
    };

    handlePostLoginSaveWorkout();
  }, [user]);

  return (
    <div className="relative min-h-screen flex flex-col items-center p-8 text-center space-y-6 overflow-hidden">
      {/* Confetti is always in the DOM but toggled via visibility */}
      <div
        className={`absolute top-1 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none z-50 transition-opacity duration-500 ${
          isExploding ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <ConfettiExplosion force={0.7} duration={3000} particleCount={250} />
      </div>

      <h2 className="text-2xl font-bold">Workout Complete! 🎉</h2>

      <div className="flex flex-col items-center gap-4">
        {!fromLibrary && (
          <button
            className="w-64 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
            onClick={handleSaveWorkout}
          >
            Save This Workout to Your Library
          </button>
        )}
        <button
          className="w-64 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          onClick={handleRestart}
        >
          Create New Workout
        </button>
      </div>
    </div>
  );
}
